import React from 'react';
import PropTypes from 'prop-types';
import QueryManager from './Query';
import gql from 'graphql-tag';
import { get } from 'lodash';

const GET_USERS = gql`
  # Write your query or mutation here
  query getUsersFeed($size: Int, $page: Int, $sort: [SortInput], $filters: [FilterInput]) {
    getUsersFeed(size: $size, page: $page, sort: $sort, filters: $filters) {
      count
      page
      results {
        ... on Picker {
          id
          idBase
          firstName
          lastName
          email
          phone
          status
          document      
          status
          createdAt
          updatedAt
          lastConnection
          typeUser
          switchAutoSala
          profiles
          statusUser
          splitUser
          company
          salesChannels {
            value: id
            id
            isActive
          }
        }
      }
    }
  }
`;
const Users = ({ children, ...props }) => {
    return (
        <QueryManager query={GET_USERS} {...props} fetchPolicy='network-only'>
            {({ data, loading, fetchMore, refetch }) =>
                children({
                    data: get(data, 'getUsersFeed.results', []),
                    count: get(data, 'getUsersFeed.count'),
                    refetch,
                    loading
                })}
        </QueryManager>
    );
};

Users.propTypes = {
    children: PropTypes.any
};

export default Users;
